import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=4c3d0886&scoped=true"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"
import style0 from "./Ratings.vue?vue&type=style&index=0&id=4c3d0886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3d0886",
  null
  
)

export default component.exports